import { ValidationErrors } from 'acscp/api/models/errorDetails';
import { addValidationError } from 'acscp/components/common/helpers/validationErrorHelpers';
import { ValidationCheck } from 'acscp/components/common/helpers/validationChecks';
import { RequestError } from 'acscp/store/requestsState';
import { combineValidationErrors } from 'acscp/components/common/helpers/validationErrorHelpers';

export interface ValidationRule {
    validatedPropertyName: string;
    validationCheck: ValidationCheck;
    errorMessage: string | (() => string);
}

/**
 * Helper class for
 * - validation of form inputs using common validation rules
 * - getting a displayed combination of all (client- and server- side) validation errors
 */
export class FormValidator {
    constructor(private validationRules: ValidationRule[]) {}

    isStateValid = () => Object.keys(this.getValidationErrors()).length === 0;

    getDisplayedErrors = (showErrors: boolean, formSubmitError: RequestError | undefined): ValidationErrors => {
        if (showErrors) {
            const clientValidationErrors = this.getValidationErrors();
            const serverValidationErrors = (formSubmitError && formSubmitError.validationErrors) || {};

            return combineValidationErrors(clientValidationErrors, serverValidationErrors);
        }
        return {};
    }

    private getValidationErrors = () => {
        const initialErrors: ValidationErrors = {};

        return this.validationRules.reduce(
            (acc, rule) =>
                rule.validationCheck()
                    ? acc
                    : addValidationError(acc, rule.validatedPropertyName,
                        (typeof rule.errorMessage === 'function') ? rule.errorMessage() : rule.errorMessage),
            initialErrors
        );
    }
}
